import dayjs from 'dayjs';
import CreateEvent from '../modules/create-event';

export default calendar => {
  let _this = calendar;
  let el = document.querySelector(_this.el);
  let ch = [...el.querySelectorAll('[data-date]')];

  for (let i = 0; i < ch.length; i++) {
    let e = ch[i]
    e.addEventListener('click', () => {
      let d = new Date(e.getAttribute('data-year'), e.getAttribute('data-month'), e.getAttribute('data-date'));
      let state = _this.state;
      let pe = e.parentElement;

      switch (state) {
        case 'select_range':
          if (!_this.checkin) {
            _this.checkin = d
            _this.checkout = undefined
          } else if (dayjs(d).isBefore(_this.checkin, 'date')) {
            _this.checkin = d
            _this.checkout = undefined
          } else if (dayjs(d).isSame(_this.checkin, 'date')) {
            return
          } else {
            _this.checkout = d
            _this.state = 'ready';
            CreateEvent('ready', {
              checkin: _this.checkin,
              checkout: _this.checkout
            }, el)
          }
          _this.renderRange()
          break;
        case 'ready':
          _this.checkin = d
          _this.checkout = undefined
          _this.state = 'select_range'
          _this.renderRange()
          break;
        default:
      }
    });

    e.addEventListener('mouseenter', () => {
      let d = new Date(e.getAttribute('data-year'), e.getAttribute('data-month'), e.getAttribute('data-date'));
      let state = _this.state;
      let pe = e.parentElement;
      pe.classList.add(_this.className.isHover);

      switch (state) {
        case 'select_range':
          if (_this.checkin && dayjs(d).isAfter(_this.checkin)) {
            _this.renderRange(_this.checkin, d)
          } else {
            _this.renderRange(_this.checkin, _this.checkin)
          }
          break;
        default:;
      }
    });

    e.addEventListener('mouseleave', () => {
      let pe = e.parentElement;
      pe.classList.remove(_this.className.isHover);
    });
  };
};
